import LeftPanelIcon from '@ordr-as/icons/LeftPanelIcon';
import type { KdsStationResponse } from '@ordr-as/ordr-service-types/epos';
import type { OrdrWsConnectionState } from '../../utils/OrdrWebSocketClient';
import StationDropdown, { type StationSelection } from './StationDropdown';

type Props = {
  stations: KdsStationResponse[];
  selection: StationSelection;
  onSelect: (selection: StationSelection) => void;
  connectionState: OrdrWsConnectionState;
  recentOpen: boolean;
  onToggleRecent: () => void;
};

const ConnectionIndicator = ({ state }: { state: OrdrWsConnectionState }) => {
  if (state === 'connected') return null;
  return (
    <span className="inline-flex items-center gap-1 text-extra-small font-semibold px-2 py-1 rounded-full bg-orange-lightest text-orange-darkest">
      <span className="w-2 h-2 rounded-full bg-orange-darkest" />
      {state === 'connecting' ? 'Connecting…' : 'Offline — retrying'}
    </span>
  );
};

const IconButton = ({
  active,
  title,
  onClick,
  children,
}: {
  active: boolean;
  title: string;
  onClick: () => void;
  children: React.ReactNode;
}) => (
  <button
    className={`w-7 h-7 rounded-full border border-grey-medium flex items-center justify-center text-brand-secondary hover:border-brand-primary transition-colors ${
      active ? 'bg-grey-lightest' : 'bg-brand-white'
    }`}
    title={title}
    onClick={onClick}
  >
    {children}
  </button>
);

const KdsToolbar = ({
  stations,
  selection,
  onSelect,
  connectionState,
  recentOpen,
  onToggleRecent,
}: Props) => (
  <div className="flex-none flex items-center gap-2 px-4 py-3">
    <StationDropdown stations={stations} selection={selection} onSelect={onSelect} />
    <ConnectionIndicator state={connectionState} />
    <div className="flex-1" />
    <IconButton active={recentOpen} title="Recently done" onClick={onToggleRecent}>
      <LeftPanelIcon width={18} height={18} style={{ transform: 'scaleX(-1)' }} />
    </IconButton>
  </div>
);

export default KdsToolbar;
